module.exports = __webpack_public_path__ + "img/img5.61a93e02.png";